import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { getTemplateTemplatesTemplateIdGetOptions } from '@/api';
import EditTemplateModal from '@/components/EditTemplateModal';
import Loader from '@/components/Loader';
import useCreateSessionTemplate from '@/hooks/useCreateSessionTemplate';
import { useEffect } from 'react';

export const Route = createFileRoute('/_auth/sessions/$id')({
  component: SessionEditPage,
});

function SessionEditPage() {
  const { id } = Route.useParams();
  const { create } = useCreateSessionTemplate();

  const {
    data: template,
    isLoading,
    error,
  } = useQuery({
    ...getTemplateTemplatesTemplateIdGetOptions({
      path: {
        template_id: id,
      },
    }),
    enabled: id !== "new"
  });

  useEffect(() => {
    if (id === "new") {
      create({
        body: {
          name: 'Untitled ',
        },
      });
    }
  }, [id]);

  if (id === "new") {
    return (
      <div className="flex items-center justify-center min-h-96">
        <Loader />
      </div>
    )
  }

  if (isLoading) {
    return <Loader />;
  }

  if (error || !template) {
    return (
      <div className="flex items-center justify-center min-h-96">
        <div className="text-center">
          <h2 className="text-2xl font-semibold text-gray-900 mb-2">
            Session Not Found
          </h2>
          <p className="text-gray-600">
            The session you're looking for doesn't exist or you don't have
            permission to access it.
          </p>
        </div>
      </div>
    );
  }

  return <EditTemplateModal key={id} data={template} />;
}
